import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserContext } from '@context/createContext';

export default function CompleteSignup({ role }) {
  const { refetch } = useContext(UserContext);

  return (
    <div className="flex flex-col w-full h-full items-center justify-center gap-8">
      <span>
        <svg className="w-36 h-36" viewBox="0 0 225 226" fill="none" xmlns="http://www.w3.org/2000/svg">
          <ellipse cx="112.5" cy="113" rx="112.5" ry="113" fill="#1BA781" fill-opacity="0.08" />
          <path
            opacity="0.4"
            d="M112.5 177.167C148.169 177.167 177.084 148.438 177.084 113C177.084 77.5616 148.169 48.8333 112.5 48.8333C76.8319 48.8333 47.917 77.5616 47.917 113C47.917 148.438 76.8319 177.167 112.5 177.167Z"
            fill="#1BA781"
          />
          <path
            d="M103.329 135.972C102.038 135.972 100.811 135.458 99.9064 134.56L81.6293 116.401C79.7564 114.54 79.7564 111.46 81.6293 109.599C83.5022 107.738 86.6022 107.738 88.4751 109.599L103.329 124.358L136.525 91.3758C138.398 89.515 141.498 89.515 143.371 91.3758C145.244 93.2367 145.244 96.3167 143.371 98.1775L106.752 134.56C105.848 135.458 104.621 135.972 103.329 135.972Z"
            fill="#1BA781"
          />
        </svg>
      </span>
      <span className="text-xl font-medium">{role} عزیز ثبت نام شما با موفقیت انجام شد</span>
      <Link onClick={() => refetch()} to={role == 'agent' ? '/agent/dashboard' : '/realStateOwner/dashboard'}>
        <button className="btn btn-primary">ورود به پنل مدیریت</button>
      </Link>
    </div>
  );
}
